module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-6.decc68e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-6.png
// module id = 196
// module chunks = 0